<template>
  <div class="device tip-page">
    <div class="tip-page-top">
      <span
        >{{ data.tipsTitle || "设备信息" }}
        <span
          :class="
            data.checkType == 'call'
              ? 'titleCall'
              : data.checkType == 'audio'
              ? 'titleAudio'
              : ''
          "
          >{{
            data.checkType == "call"
              ? "【 远程喊话 】"
              : data.checkType == "audio"
              ? "【 播放音频 】"
              : ""
          }}</span
        >
      </span>

      <el-tooltip
        class="item"
        effect="dark"
        content="关闭"
        placement="top-start"
      >
        <i @click="handleCloseTip" class="el-icon-close"></i>
      </el-tooltip>
    </div>
    <div class="tip-page-content">
      <el-row :span="24">
        <el-col :span="24">
          <div class="item-content">
            <label class="item-label">设备编号 ：</label>
            <span class="item-value">{{ data.thirdDeviceId }}</span>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="item-content">
            <label class="item-label">设备名称 ：</label>
            <span class="item-value">{{ data.thirdDeviceName }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item-content">
            <label class="item-label">设备状态 ：</label>
            <span class="item-value">{{ data.statusName }}</span>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="item-content">
            <label class="item-label">子系统 ：</label>
            <span class="item-value">{{ data.systemName }}</span>
          </div>
        </el-col>
        <!-- <el-col :span="8">
          <div class="item-content">
            <label class="item-label">规格 ：</label>
            <span class="item-value"></span>
          </div>
        </el-col> -->
        <!-- <el-col :span="15">
          <div class="item-content">
            <label class="item-label">IP地址 ：</label>
            <span class="item-value">{{ data.ip }}</span>
          </div>
        </el-col> -->
        <el-col :span="8">
          <div class="item-content">
            <label class="item-label">类型 ：</label>
            <span class="item-value">{{ data.deviceTypeName }}</span>
          </div>
        </el-col>
        <el-col :span="15">
          <div class="item-content">
            <label class="item-label">室内/外 ：</label>
            <span class="item-value">{{
              data.isIndoorName == "否" ? "室外" : "室内"
            }}</span>
          </div>
        </el-col>
        <el-col :span="8" v-if="data.deviceType == 18">
          <div class="item-content">
            <label class="item-label">监控方位：</label>
            <span class="item-value">{{ directionType[data.azimuth] }}</span>
          </div>
        </el-col>
        <!-- 
        <el-col :span="labelSpan" v-if="data.isIndoorName == '是'">
          <div class="item-content">
            <label class="item-label">楼层 ：</label>
            <span class="item-value">{{ data.floorName }}</span>
          </div>
        </el-col>
        <el-col :span="labelSpan" v-if="data.isIndoorName == '是'">
          <div class="item-content">
            <label class="item-label">建筑物 ：</label>
            <span class="item-value">{{ data.buildingName }}</span>
          </div>
        </el-col> -->
        <el-col :span="24">
          <div class="item-content">
            <label class="item-label">位置 ：</label>
            <span class="item-value">{{ data.areaName }}</span>
          </div>
        </el-col>
        <el-col :span="24">
          <div class="item-content">
            <label class="item-label">设备厂家 ：</label>
            <span class="item-value">{{ data.factoryName }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tip-page-bottom" v-if="data.deviceType == '18'">
      <el-button type="primary" @click="handleOpenVideo('live')">实况</el-button>
    </div>
    <div class="tip-page-bottom" v-if="data.deviceType == '26'">
      <el-button
        type="primary"
        @click="handleDeviceShout"
        v-if="data.checkType != 'audio'"
        >喊话</el-button
      >
      <el-button
        type="primary"
        @click="handleDeviceMusic"
        v-if="data.checkType != 'call'"
        >播放</el-button
      >
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "tipDetails",
  components: {},
  data() {
    return {
      directionType: {
        1: "东",
        2: "西",
        3: "南",
        4: "北",
        5: "东南",
        6: "东北",
        7: "西南",
        8: "西北",
      },
      labelSpan: 11,
      data: {}, //渲染数据
    };
  },
  mounted() {},
  methods: {
    //live-直播，back-录像
    handleOpenVideo(type = "live") {
      // console.log(this);
      this.$app.AppInstance.handleMiniPlay({
        playType: type,
        playTitle: this.data.thirdDeviceName, //摄像机名称
        playId: this.data.thirdDeviceId, //摄像机id
      });
    },
    // 广播喊话
    handleDeviceShout() {
      this.$emit("handleDeviceShout", this.data);
    },
    // 广播播放
    handleDeviceMusic() {
      this.$emit("handleDeviceMusic", this.data);
    },
    handleCloseTip() {
      this.$emit("tipClose");
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.flex-Between {
  display: flex;
  justify-content: space-between;
  //
}
$bgcolor: rgba(30, 40, 64, 1);
.tip-page {
  padding: 20px 30px;
  height: auto;
  font-size: 15px;
  border-radius: 5px;
  @include set_theme_color(background-color, map-panel-content);
  backdrop-filter: blur(2px);
  &-top {
    border-left: 5px solid #407aee;
    padding-left: 10px;
    height: 20px;
    line-height: 20px;
    @extend .flex-Between;
    .titleAudio {
      font-size: 14px;
      color: #ffbf00;
    }
    .titleCall {
      font-size: 14px;
      color: rgba(30, 205, 127, 1);
    }
    i {
      cursor: pointer;
      font-size: 18px;
      // color: #fff;
      @include set_theme_color(color, main-theme-color);
      position: absolute;
      top: 10px;
      right: 10px;
      pointer-events: all;
      padding: 2px;
      &:hover {
        // background: $bgcolor;
        border-radius: 50%;
        -webkit-animation: rotation 5s linear infinite;
        animation: rotation 5s linear infinite;
      }
    }
  }
  &-content {
    width: 520px;
    margin-top: 12px;
    .item-content {
      font-size: 15px;
      margin: 8px 0;
      display: flex;
      flex-direction: row;
    }
    .el-col {
      margin-right: 10px;
    }
    .item-label {
      // width: 80px;
    }
    .item-value {
      //   max-width: 220px;
    }
  }
  &-bottom {
    padding: 5px;
    text-align: center;
  }
}
@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>